export function JobDetail() {
  return <div>Job Detail - Coming Soon</div>;
}
